import { Component } from "react";
import { useI18n } from "../../i18n";

const CrashScreen = () => {
  const { t } = useI18n();
  return (
    <div className="am-crash" role="alert" data-testid="error-boundary">
      <div className="am-card max-w-md p-8">
        <h1 className="am-h2 mb-2"><span>{t("crash.title")}</span></h1>
        <p className="am-hint mb-6"><span>{t("crash.body")}</span></p>
        <div className="flex gap-3">
          <button className="am-btn am-btn-primary" onClick={() => window.location.reload()} data-testid="error-boundary-reload-button"><span>{t("crash.reload")}</span></button>
          <a className="am-btn am-btn-ghost" href="/dashboard" data-testid="error-boundary-home-link"><span>{t("crash.home")}</span></a>
        </div>
      </div>
    </div>
  );
};

export class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("UI crash", error, info?.componentStack);
  }

  render() {
    return this.state.failed ? <CrashScreen /> : this.props.children;
  }
}
